let showFn = async () => {};

export const setWarmupHandler = (show) => {
  showFn = show;
};

export const warmupController = {
  show: ({ seconds = 60 } = {}) => showFn({ seconds }),
};

